import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';
import LinkButton from '../ui/LinkButton';

interface CenteredImageTextLinkProps {
  image: React.ReactNode;
  title: string;
  text: string;
  link?: {
    url: string;
    label: string;
    openInNewTab?: boolean;
  };
  containerClassName?: string;
  imageClassName?: string;
  linkClassName?: string;
}

const CenteredImageTextLink: React.FC<CenteredImageTextLinkProps> = ({
  image,
  title,
  text,
  link,
  containerClassName = '',
  imageClassName = '',
  linkClassName = '',
}) => {
  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className={`mx-auto w-full max-w-screen-kia mt-14 flex flex-col items-center text-center px-2 sm:px-4 ${containerClassName}`}
    >
      <div className={imageClassName}>{image}</div>
      <div className="mx-auto w-full max-w-screen-sm">
        <m.h2
          variants={itemVariants}
          className="text-[32px] md:text-[32px] font-semibold mb-8 mt-4"
      
        >
          {title}
        </m.h2>
        <m.p
          variants={itemVariants}
          className= "!text-[16px] md:text-[18px] mb-4"
        >
          {text}
        </m.p>
      </div>
      {link && (
        <LinkButton
          url={link.url}
          text={link.label} 
          openInNewTab={link.openInNewTab}
          className={`mt-2 ${linkClassName}`}
        />
      )}
    </m.section>
  );
};

export default CenteredImageTextLink;

